/**
 * 로그인 전역 Store 모듈
 * @module shared/store/useAuthStore
 * @author Lian
 */
import axios from 'axios';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { CryptoManager } from '@/shared/utils/crypto/CryptoManager.ts';
/**
 * 로그인 Store Interface
 * @author Lian
 */
interface AuthState {
  /**
   * 사용자 id
   */
  userId: string | null;
  /**
   * 사용자명
   */
  userName: string | null;
  /**
   * access token
   */
  token: string | null;
  /**
   * 관리자 여부
   */
  isAdmin: boolean | null;
  /**
   * 로그인 정보 저장 함수
   */
  login: (data: { userId: string; userName: string; token: string; isAdmin: boolean }) => void;
  /**
   * 로그아웃 함수
   */
  logout: () => void;
}

/**
 * AuthStore를 생성한다.
 * @author Lian
 */
const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      userId: null,
      userName: null,
      token: null,
      isAdmin: null,
      login: ({ userId, userName, token, isAdmin }) => set({ userId, userName, token, isAdmin }),
      logout: () => {
        axios.post('/api/auth/manage/logout');
        CryptoManager.reset();
        set({ userId: null, userName: null, token: null, isAdmin: null });
      },
    }),
    {
      name: 'auth-storage',
    },
  ),
);

export default useAuthStore;
